import React, { ChangeEvent } from 'react'
import styled from '../../theme/styled'

const ArrowImg = require('./white_arrow_down.svg')

const SelectWrapper = styled.div`
  margin-left: auto;

  /* So that there's no default arrow on select-elements on IE */
  select::-ms-expand {
    display: none;
  }

  .custom-select {
    color: ${({ theme }) => theme.colors.invert};
    background: ${({ theme }) => theme.colors.light};
    appearance: none;
    width: 170px;
    height: 35px;
    margin-left: auto;
    padding: 5px 30px 5px 10px;
    border: 2px solid ${({ theme }) => theme.colors.invert};
    font-weight: 600;
    font-size: ${({ theme }) => theme.fonts.smallSize};

    /* Custom backgroud arrow */
    background-image: url(${ArrowImg});
    background-position: calc(100% - 12px);
    background-size: 8px 8px;
    background-repeat: no-repeat;
    border-radius: 0px;
  }
`

export type SelectProps = {
  options: React.ReactElement<HTMLElement>[]
  handleChange?: (value: string) => void
  handleEventChange?: (e: ChangeEvent<HTMLSelectElement>) => void
  currentVal: string
  name?: string
}

const CustomSelect = props => {
  const {
    input,
    options,
    handleChange,
    handleEventChange,
    currentVal = '',
    disabled,
    name,
    autoFocus,
    title,
    required,
    style
  } = props

  const onChange = event => {
    if (input && input.onChange) {
      input.onChange(event.target.value)
    }
    if (handleChange) {
      handleChange(event.target.value)
    } else if (handleEventChange) {
      handleEventChange(event)
    }
  }

  return (
    <SelectWrapper>
      <select
        value={currentVal}
        className="custom-select"
        onChange={event => onChange(event)}
        disabled={disabled}
        name={name}
        autoFocus={autoFocus}
        title={title}
        required={required}
        style={style}
      >
        {options}
      </select>
    </SelectWrapper>
  )
}

export default CustomSelect



// WEBPACK FOOTER //
// ./src/Components/Shared/CustomSelect.tsx